import * as C from "react";
import { useEffect as y, useRef as A, useReducer as U, useState as v, createContext as V, useContext as P, useMemo as E } from "react";
import { P as c, u as M } from "./useGetSubdivisionType-CuJXxyQE.js";
import { S as We, i as Ge, j as Ye, a as Je, b as Be, k as Xe, q as Ze, l as ze, c as De, f as et, g as tt, d as nt, e as rt, m as st, n as ot, o as ut, p as it, h as ct } from "./useGetSubdivisionType-CuJXxyQE.js";
import { g as F } from "./tailwind-BXrsiEcF.js";
function we(e = 0) {
  const [n, t] = C.useState(!1);
  return C.useEffect(() => {
    const r = () => {
      t(
        window.innerHeight + window.scrollY >= document.body.offsetHeight - e
      );
    };
    return window.addEventListener("scroll", r, { passive: !0 }), r(), () => {
      window.removeEventListener("scroll", r);
    };
  }, [e]), n;
}
function ve({
  timeout: e = 2e3
}) {
  const [n, t] = C.useState(!1);
  return { isCopied: n, copyToClipboard: (s) => {
    var o;
    typeof window > "u" || !((o = navigator.clipboard) != null && o.writeText) || s && navigator.clipboard.writeText(s).then(() => {
      t(!0), setTimeout(() => {
        t(!1);
      }, e);
    });
  } };
}
function xe(e) {
  y(() => {
    document.title = e;
  }, [e]);
}
function Ee() {
  const e = A(null);
  return { formRef: e, onKeyDown: (t) => {
    var r;
    t.key === "Enter" && !t.shiftKey && !t.nativeEvent.isComposing && ((r = e.current) == null || r.requestSubmit(), t.preventDefault());
  } };
}
function Le() {
  const [e, n] = U((t) => t + 1, 0);
  return n;
}
function Re() {
  const [e, n] = v(() => {
    var t;
    return !!((t = window.django) != null && t.reactInterpolate);
  });
  return y(() => {
    if (e) {
      const r = new MutationObserver((s) => {
        s.forEach((o) => {
          o.type === "childList" && o.removedNodes.forEach((i) => {
            i.nodeType === Node.ELEMENT_NODE && i.tagName === "SCRIPT" && i.id === "gettext-translations" && n(!1);
          });
        });
      });
      return r.observe(document.head, { childList: !0 }), () => r.disconnect();
    }
    const t = setInterval(() => {
      var r;
      (r = window.django) != null && r.reactInterpolate && n(!0);
    }, 50);
    return () => clearInterval(t);
  }, [e]), e;
}
const Ie = (e, n) => {
  const [t, r] = v(n);
  return y(() => {
    const o = window.localStorage.getItem(e);
    o && r(JSON.parse(o));
  }, [e]), [t, (o) => {
    r(o), window.localStorage.setItem(e, JSON.stringify(o));
  }];
};
var b = {}, O;
function H() {
  if (O) return b;
  O = 1, b.match = o, b.parse = i;
  var e = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, n = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, t = /^(?:(min|max)-)?(.+)/, r = /(em|rem|px|cm|mm|in|pt|pc)?$/, s = /(dpi|dpcm|dppx)?$/;
  function o(f, a) {
    return i(f).some(function(l) {
      var m = l.inverse, L = l.type === "all" || a.type === l.type;
      if (L && m || !(L || m))
        return !1;
      var x = l.expressions.every(function(g) {
        var R = g.feature, I = g.modifier, d = g.value, h = a[R];
        if (!h)
          return !1;
        switch (R) {
          case "orientation":
          case "scan":
            return h.toLowerCase() === d.toLowerCase();
          case "width":
          case "height":
          case "device-width":
          case "device-height":
            d = w(d), h = w(h);
            break;
          case "resolution":
            d = u(d), h = u(h);
            break;
          case "aspect-ratio":
          case "device-aspect-ratio":
          case /* Deprecated */
          "device-pixel-ratio":
            d = _(d), h = _(h);
            break;
          case "grid":
          case "color":
          case "color-index":
          case "monochrome":
            d = parseInt(d, 10) || 1, h = parseInt(h, 10) || 0;
            break;
        }
        switch (I) {
          case "min":
            return h >= d;
          case "max":
            return h <= d;
          default:
            return h === d;
        }
      });
      return x && !m || !x && m;
    });
  }
  function i(f) {
    return f.split(",").map(function(a) {
      a = a.trim();
      var l = a.match(e), m = l[1], L = l[2], x = l[3] || "", g = {};
      return g.inverse = !!m && m.toLowerCase() === "not", g.type = L ? L.toLowerCase() : "all", x = x.match(/\([^\)]+\)/g) || [], g.expressions = x.map(function(R) {
        var I = R.match(n), d = I[1].toLowerCase().match(t);
        return {
          modifier: d[1],
          feature: d[2],
          value: I[2]
        };
      }), g;
    });
  }
  function _(f) {
    var a = Number(f), l;
    return a || (l = f.match(/^(\d+)\s*\/\s*(\d+)$/), a = l[1] / l[2]), a;
  }
  function u(f) {
    var a = parseFloat(f), l = String(f).match(s)[1];
    switch (l) {
      case "dpcm":
        return a / 2.54;
      case "dppx":
        return a * 96;
      default:
        return a;
    }
  }
  function w(f) {
    var a = parseFloat(f), l = String(f).match(r)[1];
    switch (l) {
      case "em":
        return a * 16;
      case "rem":
        return a * 16;
      case "cm":
        return a * 96 / 2.54;
      case "mm":
        return a * 96 / 2.54 / 10;
      case "in":
        return a * 96;
      case "pt":
        return a * 72;
      case "pc":
        return a * 72 / 12;
      default:
        return a;
    }
  }
  return b;
}
var S, q;
function Q() {
  if (q) return S;
  q = 1;
  var e = H().match, n = typeof window < "u" ? window.matchMedia : null;
  function t(s, o, i) {
    var _ = this, u;
    n && !i && (u = n.call(window, s)), u ? (this.matches = u.matches, this.media = u.media, u.addListener(a)) : (this.matches = e(s, o), this.media = s), this.addListener = w, this.removeListener = f, this.dispose = l;
    function w(m) {
      u && u.addListener(m);
    }
    function f(m) {
      u && u.removeListener(m);
    }
    function a(m) {
      _.matches = m.matches, _.media = m.media;
    }
    function l() {
      u && u.removeListener(a);
    }
  }
  function r(s, o, i) {
    return new t(s, o, i);
  }
  return S = r, S;
}
var K = Q();
const W = /* @__PURE__ */ F(K);
var G = /[A-Z]/g, Y = /^ms-/, T = {};
function J(e) {
  return "-" + e.toLowerCase();
}
function $(e) {
  if (T.hasOwnProperty(e))
    return T[e];
  var n = e.replace(G, J);
  return T[e] = Y.test(n) ? "-" + n : n;
}
function B(e, n) {
  if (e === n)
    return !0;
  if (!e || !n)
    return !1;
  const t = Object.keys(e), r = Object.keys(n), s = t.length;
  if (r.length !== s)
    return !1;
  for (let o = 0; o < s; o++) {
    const i = t[o];
    if (e[i] !== n[i] || !Object.prototype.hasOwnProperty.call(n, i))
      return !1;
  }
  return !0;
}
const p = c.oneOfType([c.string, c.number]), j = {
  all: c.bool,
  grid: c.bool,
  aural: c.bool,
  braille: c.bool,
  handheld: c.bool,
  print: c.bool,
  projection: c.bool,
  screen: c.bool,
  tty: c.bool,
  tv: c.bool,
  embossed: c.bool
}, X = {
  orientation: c.oneOf(["portrait", "landscape"]),
  scan: c.oneOf(["progressive", "interlace"]),
  aspectRatio: c.string,
  deviceAspectRatio: c.string,
  height: p,
  deviceHeight: p,
  width: p,
  deviceWidth: p,
  color: c.bool,
  colorIndex: c.bool,
  monochrome: c.bool,
  resolution: p,
  type: Object.keys(j)
}, { type: be, ...Z } = X, z = {
  minAspectRatio: c.string,
  maxAspectRatio: c.string,
  minDeviceAspectRatio: c.string,
  maxDeviceAspectRatio: c.string,
  minHeight: p,
  maxHeight: p,
  minDeviceHeight: p,
  maxDeviceHeight: p,
  minWidth: p,
  maxWidth: p,
  minDeviceWidth: p,
  maxDeviceWidth: p,
  minColor: c.number,
  maxColor: c.number,
  minColorIndex: c.number,
  maxColorIndex: c.number,
  minMonochrome: c.number,
  maxMonochrome: c.number,
  minResolution: p,
  maxResolution: p,
  ...Z
}, D = { ...j, ...z };
var ee = {
  all: D
};
const te = (e) => `not ${e}`, ne = (e, n) => {
  const t = $(e);
  return typeof n == "number" && (n = `${n}px`), n === !0 ? t : n === !1 ? te(t) : `(${t}: ${n})`;
}, re = (e) => e.join(" and "), se = (e) => {
  const n = [];
  return Object.keys(ee.all).forEach((t) => {
    const r = e[t];
    r != null && n.push(ne(t, r));
  }), re(n);
}, oe = V(void 0), ue = (e) => e.query || se(e), N = (e) => e ? Object.keys(e).reduce((t, r) => (t[$(r)] = e[r], t), {}) : void 0, k = () => {
  const e = A(!1);
  return y(() => {
    e.current = !0;
  }, []), e.current;
}, ie = (e) => {
  const n = P(oe), t = () => N(e) || N(n), [r, s] = v(t);
  return y(() => {
    const o = t();
    B(r, o) || s(o);
  }, [e, n]), r;
}, ce = (e) => {
  const n = () => ue(e), [t, r] = v(n);
  return y(() => {
    const s = n();
    t !== s && r(s);
  }, [e]), t;
}, ae = (e, n) => {
  const t = () => W(e, n || {}, !!n), [r, s] = v(t), o = k();
  return y(() => {
    if (o) {
      const i = t();
      return s(i), () => {
        i && i.dispose();
      };
    }
  }, [e, n]), r;
}, le = (e) => {
  const [n, t] = v(e.matches);
  return y(() => {
    const r = (s) => {
      t(s.matches);
    };
    return e.addListener(r), t(e.matches), () => {
      e.removeListener(r);
    };
  }, [e]), n;
}, Me = (e, n, t) => {
  const r = ie(n), s = ce(e);
  if (!s)
    throw new Error("Invalid or missing MediaQuery!");
  const o = ae(s, r), i = le(o), _ = k();
  return y(() => {
    _ && t && t(i);
  }, [i]), y(() => () => {
    o && o.dispose();
  }, []), i;
};
function Se({ belowThreshold: e }) {
  const [n, t] = v(!1);
  return y(() => {
    const r = () => {
      window.scrollY > e ? t(!0) : t(!1);
    };
    return window.addEventListener("scroll", r), r(), () => {
      window.removeEventListener("scroll", r);
    };
  }, [e]), { isBelowThreshold: n };
}
function Te(e) {
  return E(() => {
    if (e) {
      const n = new Intl.Locale(e);
      let t;
      return "getTextInfo" in n && typeof n.getTextInfo == "function" ? t = n.getTextInfo() : "textInfo" in n && (t = n.textInfo), (t == null ? void 0 : t.direction) === "rtl";
    }
    return !1;
  }, [e]);
}
function Ce(e, n, t) {
  const { getConfig: r } = M({
    conversation: e,
    noticeboardData: n,
    useSystemLanguage: !0
  }), s = r(`${t}.existing_land_use_term`);
  if (s != null && s.expert_name) {
    const o = s.parsedOutput;
    if (!o || typeof o != "object") return [];
    const i = Object.keys(o).filter(
      (u) => u === "existing_land_use_term" || /^existing_land_use_term_([1-9]$)/.test(u)
    );
    if (i.length === 0) {
      const { content: u } = r(
        `${t}.existing_land_use_term`
      );
      return u ? [u] : [];
    }
    return i.map((u) => o[u]).filter(
      (u) => !!u && u.toUpperCase() !== "N/A"
    );
  }
  return [];
}
function Oe(e, n, t) {
  const { getConfig: r } = M({
    conversation: e,
    noticeboardData: n,
    useSystemLanguage: !0
  }), { content: s } = r(
    `${t}.proposed_land_use_term`
  );
  return s || "";
}
function qe(e, n, t) {
  const { getConfig: r } = M({
    conversation: e,
    noticeboardData: n,
    useSystemLanguage: !0
  }), s = r(`${t}.proposed_land_use_term`);
  if (s != null && s.expert_name) {
    const o = s.parsedOutput;
    if (!o || typeof o != "object") return [];
    const i = Object.keys(o).filter(
      (u) => u === "proposed_land_use_term" || /^proposed_land_use_term_([1-9]$)/.test(u)
    );
    if (i.length === 0) {
      const { content: u } = r(
        `${t}.proposed_land_use_term`
      );
      return u ? [u] : [];
    }
    return i.map((u) => o[u]).filter(
      (u) => !!u && u.toUpperCase() !== "N/A"
    );
  }
  return [];
}
function Ne(e, n, t) {
  var o;
  const { getConfig: r } = M({
    conversation: e,
    noticeboardData: n,
    useSystemLanguage: !0
  }), s = r(`${t}.project_details`);
  return {
    ...s,
    expert_name: s.name || "project_details",
    content: s.name ? s.content || "" : ((o = n == null ? void 0 : n.project_details) == null ? void 0 : o.raw_output) || ""
  };
}
function fe(e, n) {
  return E(() => ({ ...e != null && e.frontend_expert_output_config ? structuredClone(
    e == null ? void 0 : e.frontend_expert_output_config
  ) : void 0, ...n }), [e == null ? void 0 : e.frontend_expert_output_config, n]);
}
const de = void 0;
function Ae(e, n) {
  if (!e) return !1;
  if (["dev", "dojo"].includes(de)) return !0;
  const t = e.frontend_expert_output_config, r = t == null ? void 0 : t[n], s = r == null ? void 0 : r.enable_application_requirements;
  if (typeof s == "boolean")
    return s;
  if (typeof s == "object")
    return s.enabled ? s.councils.includes(
      e.council_code || ""
    ) : !1;
}
const pe = void 0;
function $e(e, n) {
  if (!e) return !1;
  if (["dev", "dojo"].includes(pe)) return !0;
  const t = e.frontend_expert_output_config, r = t == null ? void 0 : t[n];
  return !!(r != null && r.enable_missing_information);
}
const me = void 0;
function je(e, n) {
  if (!e) return !1;
  if (["dev", "dojo"].includes(me)) return !0;
  const t = e.frontend_expert_output_config, r = t == null ? void 0 : t[n];
  return !!(r != null && r.enable_vic_smart);
}
const he = void 0;
function ke(e, n) {
  if (!e) return !1;
  if (["dev", "dojo"].includes(he)) return !0;
  const t = e.frontend_expert_output_config, r = t == null ? void 0 : t[n];
  return !!(r != null && r.enable_vicsmart_standard_app_requirements);
}
function Ue(e) {
  const { messageType: n, messages: t } = e;
  return E(() => t == null ? void 0 : t.find((r) => r.message_type === n), [n, t]);
}
function Ve({
  conversation: e,
  noticeboardData: n
}) {
  const t = fe(e), r = t == null ? void 0 : t.enquiry;
  return E(() => {
    var i, _, u, w;
    const { expert_name: s = "", output_key: o = "" } = (r == null ? void 0 : r.missing_information_questions) || {};
    return (_ = (i = n == null ? void 0 : n[s]) == null ? void 0 : i.parsed_output) != null && _[o] ? (((w = (u = n == null ? void 0 : n[s]) == null ? void 0 : u.parsed_output) == null ? void 0 : w[o]) || []).map((a, l) => ({
      id: `${l}-${a.clause_number}`,
      question: a.exemption_text
    })) : [];
  }, [r, n]);
}
function Pe(e) {
  var n, t;
  return (n = e == null ? void 0 : e.reiteration) != null && n.raw_output ? (t = e == null ? void 0 : e.reiteration) == null ? void 0 : t.raw_output : "";
}
function Fe(e, n) {
  return E(() => e && n ? e : e == null ? void 0 : e.map((t) => ({
    ...t,
    text: t.system_language_text || t.text
  })), [e, n]);
}
function He(e, n) {
  return E(() => {
    if (e && n)
      return e;
    if (e) {
      const t = {};
      for (const [r, s] of Object.entries(e))
        t[r] = {
          ...s,
          raw_output: s.system_language_raw_output ?? s.raw_output,
          parsed_output: s.system_language_parsed_output ?? s.parsed_output
        };
      return t;
    }
  }, [e, n]);
}
export {
  oe as Context,
  We as SubdivisionType,
  se as toQuery,
  Ge as useAssessmentLights,
  we as useAtBottom,
  ve as useCopyToClipboard,
  Ye as useCouncilLocalisation,
  Je as useDebounce,
  xe as useDocumentTitle,
  Be as useDragScroll,
  Ee as useEnterSubmit,
  Ce as useExistingLandUses,
  fe as useExpertMapConfig,
  Xe as useFindAllMessageOfType,
  Ue as useFindMessageOfType,
  Le as useForceRerender,
  M as useGetReportContent,
  Ze as useGetSubdivisionType,
  ze as useHasRevisions,
  Re as useI18nReady,
  De as useInitMultiLingual,
  Ae as useIsApplicationRequirementsEnabled,
  et as useIsDetailedAnalysisEnabled,
  tt as useIsFollowUpFlowEnabled,
  $e as useIsMissingInformationEnabled,
  nt as useIsMobile,
  rt as useIsRTL,
  st as useIsReportFinalised,
  ot as useIsReportLocked,
  je as useIsVicSmartEnabled,
  ke as useIsVicSmartStandardApplicationRequirementsEnabled,
  ut as useLatestMessage,
  Ie as useLocalStorage,
  Me as useMediaQuery,
  Ve as useMissingInformationQuestions,
  it as useParsedReviews,
  Ne as useProjectDetails,
  Oe as useProposedLandUse,
  qe as useProposedLandUses,
  Pe as useReiterationExpert,
  Se as useScrollTracking,
  Te as useShouldShowRTL,
  ct as useShowVicSmartSection,
  Fe as useTranslateMessages,
  He as useTranslateNoticeboard
};
//# sourceMappingURL=hooks.js.map
